import { combineReducers } from 'redux'

import roles from './roles'
import notifications from './notifications'
import loadingUIBlocker from './loadingUIBlocker'

const application = combineReducers({
  roles,
  notifications,
  loadingUIBlocker,
})

export default application
